export const environment = {
  production: false,
  baseUrl: 'https://ncc-admin-gateway.global.fintech23.xyz',
  useMock: true,
};
